module.exports = __webpack_public_path__ + "static/media/6.47789d67.jpeg";